<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="closeDialog">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="ruleForm.username" :readonly="true" style="width: 46%;" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="ruleForm.password" show-password style="width: 46%;" placeholder="请输入密码"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { fetchAuthAppRegister, fetchMarAppRegister, userInfo } from '@/api/api'
export default{
    data() {
        return {
            title: '同步用户',
            dialogVisible: false,
            type: 1,
            ruleForm:{
                username: '',
                password: '',
            },
            data: null, // 传过来的参数
            rules: {
                 username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                ],
                 password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
            },
            personData:null
        }
    },
    created() {
      
    },
    methods:{
        closeDialog() {
            this.dialogVisible = false
            this.$refs.ruleForm.resetFields()
        },
        openDialog(data) {
          userInfo().then(res => {
              this.personData = res.data
              this.ruleForm.username = res.data.username
          })
            this.data = data
            this.dialogVisible = true
            this.ruleForm.username = this.personData.username
        },
        submitForm() {
          userInfo().then(res => {
              this.personData = res.data
              this.ruleForm.username = res.data.username
          })
            this.$refs.ruleForm.validate((valid) => {
                let params = {
                    applicationId: this.data.applicationId,
                    ...this.ruleForm
                }
                if(this.data.type === 1) {

                    fetchAuthAppRegister(params).then(res => {
                        if(res.code === 1) {
                            this.closeDialog()
                            this.$message({
                                showClose: true,
                                message: '操作成功',
                                type: 'success'
                            });
                            this.$emit('refresh')
                        }else {
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    })
                }else if(this.data.type === 2) {
                   fetchMarAppRegister(params).then(res => {
                       if(res.code === 1) {
                            this.closeDialog()
                            this.$message({
                                showClose: true,
                                message: '操作成功',
                                type: 'success'
                            });
                            this.$emit('refresh')
                        }else {
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                   })
                }
                
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/console/components/RegisterDialog.vue